import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-developer',
  templateUrl: './developer.component.html',
  styleUrls: ['./developer.component.scss']
})
export class DeveloperComponent implements OnInit {
  
  code1 = `
  {
    "success": true,
    "statusCode": 200,
    "message": "Request is successful",
    "error": null,
    "status": "OK",
    "data": {
        "access-token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MTU5NDksImNvbXBhbnlfZW1haWwiOiJheXVzaGl2eWFzMzZAZ21haWwuY29tIiwiY29tcGFueV9pZCI6Mzk2LCJjcmVhdGVkX2F0IjoiMjAyMS0wOS0yOVQwNzo0Mzo0NC4wMDBaIiwiaWF0IjoxNjQxOTg3NzEyLCJleHAiOjE2NDI1OTI1MTJ9.F9KSLSPRgviXuhcZLtyW2NV1PIPTlnqdYkN7N7XtMjg"
    },
    "errorValue": 0
}  `;
 
code2 = `{
  "status_code": 200,
  "status": "success",
  "message": "success",
  "data": [
      {
          "survey_title": "Hospital Feedback",
          "id": 1027,
          "createdAt": "2021-09-29T08:24:43.000Z"
      },
      {
          "survey_title": "Hospital Administration",
          "id": 1077,
          "createdAt": "2021-11-10T11:06:24.000Z"
      },
  
      {
          "survey_title": "Course Evaluation",
          "id": 1105,
          "createdAt": "2021-12-31T07:36:50.000Z"
      },
      {
          "survey_title": "Staff Inspection",
          "id": 1108,
          "createdAt": "2021-12-31T11:53:57.000Z"
      },
     ],
  "error": 0
} `;



  code3 = `
  <script
    src="somescript.js"
  <script/>

  <script>
    const test = 'some text'

    function logger(test) {
      console.log(test)
    }
  <script/>
  `;
  constructor() { }

  ngOnInit(): void {
  }

}
